import lazyLoading from './lazyLoading'

export default {
  name: 'Rankings',
  system: 'business_sites',
  path: '/rankings',
  meta: {
    auth: true,
    label: 'Rankings',
    icon: 'statistics',
    link: 'keywordsRanking/index.vue'
  },
  component: lazyLoading('keywordsRanking', true)
}
